import React from "react";

import AuthCardLayout from "layouts/AuthCardLayout";

import ResendConfirmationForm from "components/authentication/ResendConfirmationForm";

const ResendConfirmation = () => (
  <AuthCardLayout>
    <h3>Resend confirmation email</h3>
    <p className="mb-4">
      Enter the email address you registered with and we&apos;ll send you a
      fresh confirmation link.
    </p>
    <ResendConfirmationForm hasLabel />
  </AuthCardLayout>
);

export default ResendConfirmation;
